<p-toast position="top-right"></p-toast>
<div class="slots-reponsive p-g">
  <div class="p-g-12">
    <div class="card card-w-title">
      <h1 class="title">{{setLabel("slotsManagementLabel")}}</h1>
      <p-table #dt [value]="BookingSlots" dataKey="id" class="p-table-tecfolk-fix" styleClass="p-table-customers"
        [rowHover]="true" [rows]="10" [showCurrentPageReport]="true" [loading]="loading" [paginator]="true"
        currentPageReportTemplate="There are {{
                    BookingSlots?.length
                }} records" [filterDelay]="0" [globalFilterFields]="[
                    'name',
                    'country.name',
                    'representative.name',
                    'status'
                ]">
        <ng-template pTemplate="caption">

          <div class="reportMainFilter">
            <div class="reportMainFields">
              <div class="filterFields">
                <span class="fieldTitle">{{setLabel("searchSlotLabel")}}</span>
                <input pinputtext="" [(ngModel)]="BookingSlot.name" autocomplete="off" [placeholder]='setLabel("searchHerePlaceholderLabel")'
                  type="text" name="searchValue" (keyup)="searchLocal(BookingSlot.name, 'name')"
                  class="p-inputtext p-corner-all p-state-default p-widget" />
              </div>
              <div class="reportMainBtn">
                <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" [disabled]="loading" (click)="resetFilter()"><i
                    class="pi pi-times"></i></span>
              </div>
            </div>

            <div class="reportMainBtn">

              <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear hideOnLaptop" [disabled]="loading"
                (click)="resetFilter()"> <i class="pi pi-times"></i></span>

              <!-- <button style="background: #ffffff; color: #0e2031; margin-top: 10px;" (click)="resetFilter()"
              class="p-button p-widget p-state-default p-corner-all p-button-text-only">Clear</button>&nbsp; -->

              <span [pTooltip]='setLabel("addNewTooltipLabel")' tooltipPosition="top" routerLink="booking-slot" class="iconClear "
                [disabled]="loading"> <i class="pi pi-user-plus"></i></span>

              <!-- <button style="background: #ffffff;color: #0e2031; margin-top: 10px;" routerLink="booking-slot"
              class="p-button p-widget p-state-default p-corner-all p-button-text-only">Add New</button>&nbsp; -->

              <span [pTooltip]='setLabel("clearSlotsTooltipLabel")' tooltipPosition="top" class="iconClear" [disabled]="loading"
                (click)="resetorClearSlots()"> <i class="slots pi pi-times"></i></span>

              <!-- <button style="position: absolute;right: 21px;background: #ffffff;color: #0e2031;margin-top: 10px;
                        " (click)="resetorClearSlots()"class="p-button p-widget p-state-default p-corner-all p-button-text-only"> Clear Slots</button>&nbsp; -->
              <!-- <button style="background: #ffffff; color: #0e2031;margin-top: 10px;" (click)="printAllInvoice()"
              class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i class="fa fa-print"
                aria-hidden="true"></i> Print</button> -->
            </div>

          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th>{{setLabel("nameLabel")}}</th>
            <th>{{setLabel("totalSlotsLabel")}}</th>
            <th>{{setLabel("filledSlotsLabel")}}</th>
            <th>{{setLabel("startTimeLabel")}}</th>
            <th>{{setLabel("endTimeLabel")}}</th>
            <th>{{setLabel("actionLabel")}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-slot>
          <tr class="p-selectable-row">
            <td>
              <div class="td-title">{{setLabel("nameLabel")}}</div>
              <span class="p-column-title">{{
                slot.name
                }}</span>
            </td>
            <td>
              <div class="td-title">{{setLabel("totalSlotsLabel")}}</div>

              <span class="p-column-title">{{
                slot.totalSlots
                }}</span>
            </td>
            <td>
              <div class="td-title">{{setLabel("filledSlotsLabel")}}</div>

              <span class="p-column-title">{{
                slot.filledSlots
                }}</span>
            </td>
            <td>
              <div class="td-title">{{setLabel("startTimeLabel")}}</div>

              <span style="
                                    vertical-align: middle;

                                ">{{ slot?.startTime | date: 'shortTime' }}</span>
            </td>
            <td>
              <div class="td-title">{{setLabel("endTimeLabel")}}</div>

              <span style="
                                    vertical-align: middle;

                                ">{{ slot?.endTime | date: 'shortTime' }}</span>
            </td>
            <td>
              <div>{{setLabel("actionLabel")}}</div>

              <button pButton type="button" [pTooltip]='setLabel("deleteBookingTooltipSlotLabel")' class="p-button-danger p-button"
                icon="fa fa-times" (click)="deleteSlotById(slot)"></button>
              &nbsp;
              <button pButton type="button" [pTooltip]='setLabel("detailsTooltipLabel")' icon="fa fa-pencil-square-o"
                routerLink="booking-slot/{{ slot._id }}"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" style="text-align: left;">
              {{setLabel("noSlotsFoundLabel")}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<!-- <p-dialog header="Add Fee" [(visible)]="dialogVisibility">
  <form #feeForm="ngForm" style="height: 250px; width: 570px;">
    <div class="p-g-12 p-md-12">
      <div class="p-inputgroup">
        <p-dropdown [options]="feesOptions" name="status" (onChange)="feeChange()" [style]="{'width':'100%'}" required
          [(ngModel)]="fund.status">
        </p-dropdown>
        <p-dropdown [options]="months" (onChange)="feeChange()" name="months" [style]="{'width':'100%'}" required
          [(ngModel)]="fund.month">
        </p-dropdown>
        <p-dropdown [options]="years" (onChange)="feeChange()" name="year" [style]="{'width':'100%'}" required
          [(ngModel)]="fund.year">
        </p-dropdown>
      </div>
    </div>
    <div class="p-g-12 p-md-12">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">PKR </span>
        <input type="number" style="width: 100% !important;" required pattern="[0-9]+" autocomplete="off" pInputText
          placeholder="Price" name="fundPay" [(ngModel)]="fund.pay" #fundPay="ngModel" (input)="checkfeegreater()"
          [ngClass]="fundPay.invalid && (fundPay.dirty || fundPay.touched) ? 'errorInput' : '' ">
        <span class="p-inputgroup-addon">.00</span>
      </div>
      <div *ngIf="fundPay.invalid && (fundPay.dirty || fundPay.touched)">
        <div *ngIf="fundPay.errors.required" class="errorShow">
          Please Enter Fee Correctly.
        </div>
        <div *ngIf="fundPay.errors.pattern" class="errorShow">
          Please Enter Fee Correctly.
        </div>
      </div>
    </div>
    <p-footer>
      <button (click)="addFund()" [disabled]="!feeForm.valid || feegreater==true || feealreadypaid==true" pButton
        type="button" label="Save" icon="pi pi-save" class="p-button-success"></button>
        <br>
        <br>
        <div class="alert alert-danger">
          <p-message severity="error" text="Fee already paid" *ngIf="feealreadypaid"></p-message>
        </div>
        <div class="alert alert-danger">
          <p-message severity="error" text="You cannot pay more than actual Fee" *ngIf="feegreater"></p-message>
        </div>
    </p-footer>
  </form>
</p-dialog> -->